import { render, staticRenderFns } from "./VideoCategories.vue?vue&type=template&id=284d3f9c&scoped=true&"
import script from "./VideoCategories.vue?vue&type=script&lang=js&"
export * from "./VideoCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d3f9c",
  null
  
)

export default component.exports